module.exports = __webpack_public_path__ + "img/homePei1.b5305c1f.png";